let edts = [];

const getAllEdts = () => {
  if(localStorage.getItem('edt.edts') !== null) {
    edts = JSON.parse(localStorage.getItem('edt.edts'))
  }
  return edts;
}

const addEdt = (edt) => {
  const edtIndex = edts.findIndex(elt => elt.id === edt.id);
  if(edtIndex === -1) {
    edts.push({
      ...edt,
      favorite: false,
    });
  } else {
    edts[edtIndex].name = edt.name;
  }
  localStorage.setItem('edt.edts', JSON.stringify(edts));
}

const getEdt = (edtId) => {
  const oldEdt = edts.find(elt => elt.id === edtId);
  if(oldEdt !== undefined) {
    return oldEdt;
  }
}

const removeEdt = (edtId) => {
  const edtIndex = edts.findIndex(elt => elt.id === edtId);
  if(edtIndex !== -1) {
    edts.splice(edtIndex, 1);
  }
  localStorage.setItem('edt.edts', JSON.stringify(edts));
}

const removeAllEdts = () => {
  edts = [];
  localStorage.removeItem('edt.edts');
}

const updateEdt = (edt) => {
  const edtIndex = edts.findIndex(elt => elt.id === edt.id);
  if(edtIndex !== -1) {
    edts[edtIndex] = edt;
  }
  localStorage.setItem('edt.edts', JSON.stringify(edts));
}

const updateFavoriteEdt = (edt) => {
  edts = edts.map((elt) => {
    if(elt.id !== edt.id) {
      elt.favorite = false;
    }
    
    return elt
  })
  updateEdt(edt);
}

const getFavoriteEdt = () => {
  return edts.find(elt => elt.favorite);
}


export {
  getAllEdts,
  addEdt,
  edts,
  removeEdt,
  removeAllEdts,
  getEdt,
  updateEdt,
  updateFavoriteEdt,
  getFavoriteEdt,
}


// WEBPACK FOOTER //
// ./src/libs/EdtHandler.js